<app-sidebar
  layoutVariant="provider"
  [menuItems]="menuItems"
  [callToAction]="callToAction"
  [footerItems]="footerItems"
  title="Provider"
>
</app-sidebar>



